// Пульсирующая красная обводка по краям экрана, пока у игрока
// активен запрос на удаление аккаунта (Этап 46.22).
// Подключается один раз в App.tsx; сам читает флаг из store.

import { useGameStore } from '../store/useGameStore';
import styles from './DeletionWarning.module.css';

export function DeletionWarning() {
  const deletionScheduledAt = useGameStore(s => s.player.deletionScheduledAt);
  if (!deletionScheduledAt) return null;
  return <div className={styles.frame} />;
}
